// @ts-nocheck
if (!window.videoObserver) {
  function loadVideo(video) {
    let source = video.querySelector('source')
    if (!source) {
      const srcs = JSON.parse(video.getAttribute('data-srcs') || '[]')
      srcs.forEach((src) => {
        source = document.createElement('source')
        source.setAttribute('type', src.type)
        source.setAttribute('src', src.src)
        video.appendChild(source)
        video.classList.remove('blur-sm')
      })
    }
  }

  window.videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio < 0.5 && !entry.target.paused) {
          entry.target.pause()
        } else if (entry.intersectionRatio >= 0.5 && entry.target.paused) {
          loadVideo(entry.target)
          const $splideSlide = entry.target.closest('.splide__slide')
          if ($splideSlide) {
            // If it's in a splide slide, pause because we have splide events handling play/pause
            entry.target.pause()
          } else {
            entry.target.play()
          }

          // GA tracking for video play
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'videoPlay',
            videoName:
              entry.target.getAttribute('alt') ||
              [...entry.target.querySelectorAll('source')]?.at(-1)?.getAttribute('src') ||
              'Unnamed video',
          })
        }
      })
    },
    { threshold: [0.1, 0.25, 0.5, 0.75, 0.9] }
  )

  const $$videos = document.querySelectorAll('[data-lazy-video]')
  $$videos.forEach(($video) => {
    window.videoObserver.observe($video)
    $video.loadVideo = () => loadVideo($video)
  })
}
